import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const CraftIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.156 2.73319C20.156 1.9176 20.8172 1.25574 21.6327 1.25574C22.4483 1.25573 23.1095 1.91707 23.1095 2.73266V4.25574H20.156V2.73319Z"
        fill="currentColor"
      />
      <path
        d="M20.156 5.25574H23.1095L23.1095 17.2533H20.156V5.25574Z"
        fill="currentColor"
      />
      <path
        d="M20.156 18.2533V18.3754C20.156 19.2833 21.4456 21.3247 21.6328 21.3247C21.8199 21.3247 23.1095 19.2833 23.1095 18.3754V18.2533H20.156Z"
        fill="currentColor"
      />
      <path
        d="M17.3534 9.86797L13.9207 9.86068L13.9207 2.25574L17.3534 2.26303L17.3534 9.86797Z"
        fill="var(--cdl-chart-yellow-base)"
        stroke="var(--cdl-chart-yellow-base)"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6049 22H2.66675V6.06189L18.6049 22Z"
        fill="var(--cdl-bg-base)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41357 15.2786L9.38833 18.2533H6.41357L6.41357 15.2786Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CraftIcon;
